<template>

    <v-app-bar @click.stop="selectComponent(model)"
      :class="[ {  'dr-simple-layout-selected' : isSelected}]"
      :dark=model.DarkMode
      :color=model.Color
      :collapse=model.Collapse 
      :dense=model.Dense
      :flat=model.Flat
      :extended=model.Extended
      :prominent=model.Prominent
      :short=model.Short
      :app="!isInEditorMode"
    >
    <portal to="action-buttons" v-if="isSelected">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled='readonly' v-on="on" text color="error" @click="onDeleteComponent">
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg"/>
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
    </portal>

    <v-app-bar-nav-icon></v-app-bar-nav-icon>

    <v-toolbar-title v-if="model.Title">{{model.Title}}</v-toolbar-title>



<!-- режим корректировки -->
    <draggable v-if="isInEditorMode"
      class="draggable-target-toolbar"
      :group="{ name:'container', put:['toolbox', 'container'] }"
      @add="onWidgetDraggableAdd"
      :swapThreshold="0.95"
      :emptyInsertThreshold="20"
      @update="onModelChanged"
      @change="onDraggableChanged"
      @start="onStartDraggable"
      :disabled="readonly"
      :list="model.Widgets" >

      <component v-for="widget in model.Widgets"
        :parentsWidgets="currentListOfParentsWidgets"
        :readonly='readonly'
        :key="widget.$ID"
        :is="widget.$Type"
        :model="widget"
        @modelChanged="onModelChanged"
        @deleteComponent="onDeleteWidget"
        />

    </draggable>
    <!-- режим проигрывания -->
    <template v-else v-for="widget in model.Widgets">
      <component
        :dataSource="dataSource"
        :parentDataWidget="parentDataWidget"
        @callDataSourceAction="$emit('callDataSourceAction', $event)"
        :key="widget.$ID"
        :is="widget.$Type"
        :model="widget"/>
    </template>


    </v-app-bar>

</template>

<script>
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import jsonPatchMixin from '../../mixins/jsonPatchMixin'

export default {
  mixins: [mixin, widgetsWrapperMixin, jsonPatchMixin],
  methods: {
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    },
    // Удаление веррхних компонентов в simpleLayput
    onDeleteWidget(val) {
      this.model.Widgets = this.model.Widgets.filter(comp => comp != val)
      this.$emit('modelChanged', this.model)
      this.widgetsHelper.setSelectedWidget(undefined)
    }
  }
}
</script>

<style>
.draggable-target-toolbar{
  display: flex;
  align-items: center;
  min-width: 100px;
  height: 100%;
  flex: 1;
  outline: 1px dashed #FFA500;
}
.draggable-target-toolbar:empty::after{
  content: "Drop widgets here";
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  padding: 0 10px;
  color: #FFA500;
}

.draggable-target-toolbar /deep/ .dr-layout-placeholder-readonly {
    width: 100%;
    min-height: 40px;
    height: 100%;
}

.draggable-target-simple-layout /deep/.v-toolbar {
  contain: none !important;
}

.draggable-target-simple-layout /deep/.v-toolbar /deep/.v-toolbar__content {
  z-index: auto !important;
}

#toolbar_simple_layout /deep/ .draggable-target-simple-layout {
  min-height: 40px !important;
  display: flex;
  align-items: center;
}

.draggable-target-simple-layout /deep/ .v-toolbar {
  transform: none !important;
}

</style>
